export class Helper
{

  /**
   * イージング
   */
  private easing = {
    // no easing, no acceleration
    linear: (t: number) => { return t },
    // accelerating from zero velocity
    easeInQuad: (t: number) => { return t*t },
    // decelerating to zero velocity
    easeOutQuad: (t: number) => { return t*(2-t) },
    // acceleration until halfway, then deceleration
    easeInOutQuad: (t: number) => { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
    // accelerating from zero velocity
    easeInCubic: (t: number) => { return t*t*t },
    // decelerating to zero velocity
    easeOutCubic: (t: number) => { return (--t)*t*t+1 },
    // acceleration until halfway, then deceleration
    easeInOutCubic: (t: number) => { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
    // accelerating from zero velocity
    easeInQuart: (t: number) => { return t*t*t*t },
    // decelerating to zero velocity
    easeOutQuart: (t: number) => { return 1-(--t)*t*t*t },
    // acceleration until halfway, then deceleration
    easeInOutQuart: (t: number) => { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
    // accelerating from zero velocity
    easeInQuint: (t: number) => { return t*t*t*t*t },
    // decelerating to zero velocity
    easeOutQuint: (t: number) => { return 1+(--t)*t*t*t*t },
    // acceleration until halfway, then deceleration
    easeInOutQuint: (t: number) => { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }
  };

  constructor() {}

  /**
   * inview スクロールがselectorに到達したときに.is-inviewをaddClassする
   * @param selectors
   * @param delay
   */
  public inview(selectors: string, delay: number = 0): void {
    // 実行関数
    const fn = (): void => {
      //e.stopPropagation();
      const target = document.querySelectorAll(selectors + ':not(.is-inview)');
      const top = window.pageYOffset + window.innerHeight;
      target.forEach((el) => {
        const objTop = el.getBoundingClientRect().top + window.pageYOffset;
        if (top >= objTop) {
          if (delay === 0) {
            el.classList.add('is-inview');
            return;
          }
          setTimeout((): void => {
            el.classList.add('is-inview');
          }, delay);
        }
      });
    };
    // イベント登録
    window.addEventListener('load', fn);
    window.addEventListener('scroll', fn);
    window.addEventListener('resize', fn);
  }

  /**
   * スクロールしたらフェードイン表示
   * @param selectors
   * @param offset
   */
  public scrollFade(selectors: string, offset: number = 400): void {
    // const topBtn = $(selectors);
    const items = document.querySelectorAll(selectors);
    const fn = (e: Event, el: Element): void => {
      e.target;
      if (window.pageYOffset > offset) {
        $(el).fadeIn();
      } else {
        $(el).fadeOut();
      }
    };
    items.forEach((el): void => {
      window.addEventListener('load', (e): void => { fn(e, el); });
      window.addEventListener('scroll', (e): void => { fn(e, el); });
      window.addEventListener('resize', (e): void => { fn(e, el); });
    });
  }

  /**
   * SPメニュー展開
   */
  public header(): void {
    const button = document.querySelector('[data-js="headerSpMenuButton"]');
    const toggleClassTarget = document.querySelectorAll('.header__switch, .header__nav');
    const fn = (e: Event): void => {
      e.stopPropagation();
      if (!toggleClassTarget) return;
      toggleClassTarget.forEach((el) => {
        el.classList.toggle('is-active');
      });
    };
    if (button) {
      button.addEventListener('click', fn);
    }
  }

  /**
   * スムーズスクロール
   * @param selectors
   */
  public smoothScroll(selectors: string): void {

    // 設定
    const links = document.querySelectorAll(selectors);
    const duration = 500;

    const position = (start: number, end: number, elapsed: number, duration: number): number => {
      if (elapsed > duration) return end;
      return start + (end - start) * this.easing.easeInOutCubic(elapsed / duration);
    };

    // 実行関数
    const fn = (e: Event, el: Element): void => {
      e.preventDefault();
      let targetPos = 0;
      const href = el.getAttribute('href');
      if (href && href != '#') {
        const targetElm = document.querySelector(href);
        if (!targetElm) return;
        targetPos = targetElm.getBoundingClientRect().top;
      }
      const startTime = Date.now();
      const scrollFrom = window.pageYOffset;
      let pos = 0;
      (function loop() {
        let currentTime = Date.now() - startTime;
        if(currentTime < duration) {
          pos = position(scrollFrom, targetPos, currentTime, duration);
          window.scrollTo(0, pos);
          window.requestAnimationFrame(loop);
        } else {
          window.scrollTo(0, targetPos);
        }
      })();
    };

    links.forEach((el): void => {
      el.addEventListener('click', (e): void => {
        fn(e, el);
      });
    });
  }

  /**
   * wrapでselectorsをラップする
   * @param selectors
   * @param wrap
   * @param className
   */
  public wrap(selectors: string, wrap: string = 'div', className: string = '') {
    const array = document.querySelectorAll(selectors);
    const wrapper = document.createElement(wrap);
    if (className) wrapper.classList.add(className);
    array.forEach((el): void => {
      if (!el.parentNode) return;
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    });
  }

  /**
   * 動画のポップアップ
   */
  public movie(trigger: string, selector: string, iframe: string): void {
    $(trigger).on('click', (): void => {
      const target: string = $(trigger).attr('data-selector');
      $(`${target}__content`).append(iframe);
      $(target).fadeIn(300);
    });
    $(selector).each(function(this: HTMLElement, index: number, element: HTMLElement): void {
      $(this).on('click', (): void => {
        $(this).fadeOut(300);
        try {
          $(`${selector}__content iframe`, this).remove();
        } catch (e) {}
      });
      $(`${selector}__close`, this).on('click', (e: Event): void => {
        e.stopPropagation();
        $(this).fadeOut(300);
        try {
          $(`${selector}__content iframe`, this).remove();
        } catch (e) {}
      });
      $(`${selector}__content`, this).on('click', (e: Event): void => {
        e.stopPropagation();
      });
    })
  }
}
